var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteboxmobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 162,
    viewBox: "0 0 316 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.59062C0 1.60758 1.60758 0 3.59062 0H312.409C314.392 0 316 1.60758 316 3.59062V156.016C316 159.321 313.321 162 310.016 162H5.98437C2.67929 162 0 159.321 0 156.016V3.59062Z",
    fill: "#E5E5E5",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.59062C0 1.60757 1.60758 0 3.59062 0H312.409C314.392 0 316 1.60758 316 3.59062V154.016C316 157.321 313.321 160 310.016 160H5.98437C2.67929 160 0 157.321 0 154.016V3.59062Z",
    fill: "#E5E5E5",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.59062C0 1.60758 1.60758 0 3.59062 0H312.409C314.392 0 316 1.60758 316 3.59062V152.016C316 155.321 313.321 158 310.016 158H5.98437C2.67929 158 0 155.321 0 152.016V3.59062Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.59062C0 1.60758 1.60758 0 3.59062 0H312.409C314.392 0 316 1.60758 316 3.59062V150.016C316 153.321 313.321 156 310.016 156H5.98437C2.67929 156 0 153.321 0 150.016V3.59062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboxmobile);
export default __webpack_public_path__ + "static/media/whiteboxmobile.754238b1451b9c4986744804ce481f42.svg";
export { ForwardRef as ReactComponent };